import { useTranslation } from 'react-i18next'

interface Props {
  title: string
  description: string
}

/**
 * Görünür-pasif içerik bölümü (039, clarify A): Gündem/Prensip/Karar/Aksiyon için yerleşim hazır tutulur;
 * ekle/düzenle/sil <b>devre dışıdır</b> ("yakında"). İşlevsellik + persistence analist içerik tabloları
 * geldiğinde açılır (research D6). Bu sürümde yalnız başlık + açıklama + pasif "ekle" gösterilir.
 */
export default function DeferredSection({ title, description }: Readonly<Props>) {
  const { t } = useTranslation()
  // aria-disabled section'a KONMAZ: bölümün örtük rolü (region/generic) bu niteliği desteklemez, ekran
  // okuyucuda hiçbir karşılığı yoktur. Pasiflik zaten tek etkileşimli öğede (aşağıdaki buton) disabled
  // ile ifade edilir; görsel sönüklük .minutes-section--deferred sınıfından gelir.
  return (
    <section className="minutes-section minutes-section--deferred">
      <div className="minutes-section-head">
        <h2>{title}</h2>
        <span className="minutes-soon">{t('minutes.deferred.soon')}</span>
      </div>
      <p className="minutes-deferred-desc">{description}</p>
      <button type="button" className="minutes-deferred-add" disabled>
        <i className="pi pi-plus" aria-hidden /> {t('minutes.deferred.add')}
      </button>
    </section>
  )
}
